import React from "react";
import FileVO from "../../../ts/common/FileVO";
import CardDownloadView from "./CardDownloadView";

interface IProps
{
    fileVOs: FileVO[];
    narrow?: boolean;
    cardType?:string
    useID?:string
    tableTitle?:string
    tableDescription?:string
}
const CardDeckDownloadView = (props: IProps) =>
{
    const rowData = (props.cardType == 'panel') ? ' d-flex row-cols-1 row-cols-lg-' + ( (props.narrow || props.fileVOs.length == 1 ) ? 1 : 2 )  + ' gx-4 gy-4 blog-listing mt-2' : (' d-flex align-items-stretch row-cols-1 row-cols-md-2 row-cols-lg-' + '' +  ' gx-4 gy-4 mt-2');
    const useID = props.useID ? props.useID : ('cardDownloadDeck-' + Math.random())
    return <>

        {!!props.tableTitle || !!props.tableDescription && <>
            <div className="row">
                <div className="col">

                    {!!props.tableTitle && <>
                        <h3 className="table-heading">{props.tableTitle}</h3>
                    </>}
                    {!!props.tableDescription && <>
                        <p className="mb-4">{props.tableDescription}</p>
                    </>}

                </div>
            </div>
        </>}

        <div className={"row "+rowData} id={useID}>


            {props.fileVOs.map((fileVO, index) =>
            {

                return <div
                    className="col"
                    key={index}
                >
                    { (props.cardType == 'panel') ?
                        <></> :
                        <CardDownloadView
                            fileVO={fileVO}
                        />
                    }
                </div>;
            })}

        </div>
    </>
}
export default CardDeckDownloadView;